import { Modal } from '@mui/material';
import { MouseEvent, memo } from 'react';

type Props = {
  open: boolean;
  title: string;
  body?: string;
  actionLabel: string;
  onConfirm: () => void;
  onDismiss: () => void;
};

export const ActionConfirmModal = memo(
  ({ open, title, body, actionLabel, onConfirm, onDismiss }: Props) => (
    <Modal open={open} onClose={onDismiss}>
      <div
        onClick={(event: MouseEvent<HTMLDivElement>) => event.stopPropagation()}
        className="absolute left-1/2 top-1/2 w-[326px] -translate-x-1/2 -translate-y-1/2 rounded bg-white shadow-[0px_0px_1px_#EAECF0,0px_32px_64px_-12px_rgba(29,41,57,0.08)] md:w-[600px]"
      >
        <div className="flex p-8">
          <h4 className="text-xl font-bold">{title}</h4>
        </div>
        {body && (
          <div className="flex px-8 py-2">
            <p>{body}</p>
          </div>
        )}
        <div className="flex justify-end gap-4 p-8">
          <button
            type="button"
            onClick={onDismiss}
            className="font-medium text-[#6B7280]"
          >
            Dismiss
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="rounded bg-[#DA0000] px-4 py-2 font-medium text-white"
          >
            {actionLabel}
          </button>
        </div>
      </div>
    </Modal>
  ),
);

ActionConfirmModal.displayName = 'ActionConfirmModal';
